import { useReadyPcsV2ContextOptional } from '@components/common/ReadyPcsV2/context/ReadyPcsV2Context';
import { useManageReadyPcsV2, UseManageReadyPcsV2Params } from './useManageReadyPcsV2';

export const useReadyPcsV2Values = (props: UseManageReadyPcsV2Params) => {
  const contextValues = useReadyPcsV2ContextOptional();
  const computedValues = useManageReadyPcsV2(props);
  return contextValues ?? computedValues;
};
